import { useWallet } from "@solana/wallet-adapter-react";
import { useIsConnectionRestored, useTonAddress } from "@tonconnect/ui-react";
import { PropsWithChildren, useEffect } from "react";
import { useAccount } from "wagmi";

import { useStore } from "@/hooks/store";

import { useBackendAuth } from "../ton-provider/backAuth";


export const AccountsProvider = ({ children }: PropsWithChildren) => {
  useBackendAuth();
  const updateAccounts = useStore((store) => store.updateAccounts);

  const connectionRestored = useIsConnectionRestored();
  const { publicKey } = useWallet();
  const solanaAccount = publicKey?.toString();
  const tonAccount = useTonAddress();

  const { address } = useAccount();

  useEffect(() => {
    if (solanaAccount) updateAccounts({ solanaAccount });
    if (address) updateAccounts({ evmAccount: address });
    if (tonAccount && connectionRestored) updateAccounts({ tonAccount });
  }, [solanaAccount, updateAccounts, address, connectionRestored, tonAccount]);

  return <>{children}</>;
};
